import ICSButton, { ICSButtonProps } from '../Button/ICSButton'
import React from 'react'

import './ICSActionButton.css'

const ICSActionButton = (props: ICSButtonProps) => {
  props = { ...props, className: 'ics-action-button' }
  return <ICSButton {...props} />
}

export default ICSActionButton
